export default {
  methods: {
    buildSelectedFiltersQuery(filterParams) {
      const selectedFilters = {}
      // assign selected brands
      selectedFilters.brands = [...filterParams.brands].sort().join(',')
      selectedFilters.others = [...filterParams.others].sort().join(',')
      const sortedSelectedFilterTypes = this.sortObjectKeys(filterParams.type)
      // translate selected filterTypes and filterValues to friendly SEO url
      for (const [filterType, filterValues] of Object.entries(
        sortedSelectedFilterTypes
      )) {
        // .sort will modify the original array due to shallow copy.
        // Modifying it in place will trigger the "filterParams" watcher again (infinite loop).
        // Using the spread operator to copy the array out to prevent the watcher from triggering on sort
        selectedFilters[filterType] = [...filterValues].sort().join(',')
      }
      return selectedFilters
    },

    sortAndBuildUrlQuery(params) {
      let query = { ...this.$route.query }
      let sortingQs = {
        language: params.language || query.language,
        page: params.page || query.page,
        view: params.view || query.view,
        sort: params.sort || query.sort,
        brands: params.brands || query.brands,
        'min-price': params['min-price'] || query['min-price'],
        'max-price': params['max-price'] || query['max-price'],
        others: params.others || query.others
      }
      // merging with selected filter query strings(if any)
      sortingQs = Object.assign(sortingQs, params)

      // remove being sorted key values in route query
      // making sure values are not accidentally mixing later
      Object.keys(sortingQs).forEach((key) => delete query[key])

      // merging all unsorted query strings left from query
      query = { ...sortingQs, ...query }

      for (const [key, values] of Object.entries(query)) {
        if ([null, undefined, ''].includes(values)) delete query[key]
      }
      this.$router.push({ query })
    },

    sortObjectKeys(unorderedObject) {
      return Object.keys(unorderedObject)
        .sort()
        .reduce((obj, key) => {
          obj[key] = unorderedObject[key]
          return obj
        }, {})
    }
  }
}
